// getNextAndPreviousPage.js
'use strict';

const PAGE_START = 1;

/**
 * Get next and previous page
 * @param {number|undefined} currentNextPage - current next page.
 * @param {number|undefined} currentPreviousPage - current previous page.
 * @param {number} currentPage - current page.
 * @param {number|undefined} lastPage - last page number.
 * @param {boolean} shouldIgnoreCurrentResult - should ignore `currentNextPage` and `currentPreviousPage`.
 * @return {object} return object include nextPage and previousPage.
 */
const getNextAndPreviousPage = ({
  currentNextPage,
  currentPreviousPage,
  currentPage,
  lastPage,
  shouldIgnoreCurrentResult,
}) => {
  // `lastPage` is null means current page is last page or total count is < page limit
  const isLastPage = lastPage == null || currentPage >= lastPage;
  const isFirstPage = currentPage <= PAGE_START;
  const isContinued =
    currentPage == currentNextPage || currentPage == currentPreviousPage;
  const shouldReset = !isContinued || shouldIgnoreCurrentResult;
  return {
    nextPage: isLastPage
      ? undefined
      : currentPage == currentNextPage || shouldReset
      ? +currentPage + 1
      : currentNextPage == null
      ? undefined
      : +currentNextPage,
    previousPage: isFirstPage
      ? undefined
      : currentPage == currentPreviousPage || shouldReset
      ? +currentPage - 1
      : currentPreviousPage == null
      ? undefined
      : +currentPreviousPage,
  };
};

export default getNextAndPreviousPage;
